/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Autocomplete, Box, Button, ButtonGroup, FormControl, FormControlLabel, FormGroup, IconButton, InputLabel, LinearProgress, Menu, MenuItem, Select, SwipeableDrawer, Switch, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef, GridFilterModel, GridPaginationModel } from "@mui/x-data-grid";
import { act, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import SelectBoxSearch from "src/shared/components/select_box_search";
import { selectGtoState, useDispatch, gerenciaTecnicaSlice, mainSlice } from "src/stateManagement/redux";
import { selectMainState } from "../../../../stateManagement/redux";
import { getLocations } from "src/stateManagement/redux/slices/gerencia_tecnica/asyncReducers";
import { Location } from "src/stateManagement/redux/slices/location/interfaces";
import TuneIcon from '@mui/icons-material/Tune';
import { Filter, FilterDrawer, FilterList } from "src/shared/modules/filterDrawer";
import moment from "moment";
import DownloadIcon from '@mui/icons-material/Download';
import { convertArrayOfObjectsToCSV } from "src/shared/util/functions";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CloseIcon from '@mui/icons-material/Close';
import './styles.scss';
import { ActivitiesByDatesToAssigned, ActivitiesManagerModule } from "./components/activityManagerModule";
import RestartAltOutlinedIcon from "@mui/icons-material/RestartAltOutlined";
import { downloadExcelFormatAnalyst } from "src/shared/util/downloadExcel";
import { toast } from "react-toastify";
import { tableStyles } from "src/shared/util/tableStyles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Swal from "sweetalert2";
import { assignedActivitiesToUser } from "src/shared/util/updateDataServer";

const defaultFilters: FilterList[] = [
    {
        name: 'Fecha Inicio',
        field: 'fromDate',
        type: 'date',
        action: 'equalAfter',
        buttons: [],
        options: []
    },
    {
        name: 'Fecha Fin',
        field: 'toDate',
        type: 'date',
        action: 'equalBefore',
        buttons: [],
        options: []
    },
    {
        name: 'Pendiente de Analizar',
        field: 'lastActivityAnalized',
        type: 'groupButton',
        buttons: [
            { id: 0, name: 'Todo', value: '', action: 'dissable' },
            { id: 1, name: 'Si', value: false, action: 'equal' },
            { id: 2, name: 'No', value: true, action: 'equal' },
        ],
        options: []
    },
    {
        name: 'Método',
        field: 'method',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ['BM', 'BCP', 'ESP', 'Gas Lift']
    },
    {
        name: 'Campo',
        field: 'field',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ['Bachaquero', 'Lagunillas']
    },
    // {
    //     name: 'Cuadrillas',
    //     field: 'field',
    //     type: 'Autocomplete',
    //     action: 'include',
    //     buttons: [],
    //     options: ['Echometer', 'Leutert']
    // },
    {
        name: 'Con Data de Campo',
        field: 'activityId',
        type: 'groupButton',
        buttons: [
            { id: 0, name: 'Todo', value: "", action: 'dissable' },
            { id: 1, name: 'SI', value: "", action: 'different' },
            { id: 2, name: 'NO', value: "", action: 'equal' }
        ],
        options: []
    },
    {
        name: 'Sector',
        field: 'zone',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ["BTS1", "BTS2", "BTN2", "BTN3", "BTNB", "LGN2", "LGS1", "LGN1", "LGS2", "BTNA"]
    },
    {
        name: 'Estado Operativo Inicio',
        field: 'opeStatusInicio',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ['Operando', 'Sin Aporte', 'Aportando', 'Restaurado', 'Recolocado', 'Sin Producción', 'IT', 'Sin Acceso', 'Observación']
    },
    {
        name: 'Estado Operativo Fin',
        field: 'opeStatusFin',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ['Operando', 'Sin Aporte', 'Aportando', 'Restaurado', 'Recolocado', 'Sin Producción', 'IT', 'Sin Acceso', 'Observación']
    }
]

const ListLocation = () => {
    const dispatch = useDispatch();
    const { listOfLocationWithData } = useSelector(selectGtoState);

    const { users } = useSelector(selectGtoState);

    const [menuDetails, setMenuDetails] = useState<null | HTMLElement>(null);
    const openMenuDetails = Boolean(menuDetails);

    const { activeUser } = useSelector(selectMainState);
    const options: string[] = ["Locación"];
    const [data, setData] = useState<Location[]>([]);

    const [datatoAssigned, setDataToAssigned] = useState<Location[]>([]);

    const [selectedOption, setSelectedOption] = useState(options[0]);
    const [filters, setfilters] = useState<FilterList[]>(defaultFilters)
    const [loadFilterFromState, setloadFilterFromState] = useState(true)

    const [showAssignedModule, setShowAssignedModule] = useState(false)


    const formatFilters = (parsedFilters: any[]) => {
        let inputFilter = ""
        const newFilters = []

        if (parsedFilters && parsedFilters.length > 0) {
            for (const filter of parsedFilters) {
                if (typeof filter.value === "string" && (filter.action === 'equalAfter' || filter.action === 'equalBefore')) {
                    newFilters.push({
                        ...filter,
                        value: moment(filter.value)
                    })
                } else if (filter.name === "filterInput") {
                    inputFilter = filter.inputValueFilter || "";
                    newFilters.push(filter)
                } else {
                    newFilters.push(filter)
                }
            }
        }

        return { newFilters, inputFilter };
    }

    const getInitialLoadFilterFromState = ({ type }: { type: "paginationModel" | "filterInput" | "others" | "activeProfile" }) => {
        const locatFilters = localStorage.getItem("locationListsFilters");
        const previousFilterForLocationInput = locatFilters ? JSON.parse(locatFilters) : null;
        const { newFilters, inputFilter } = formatFilters(previousFilterForLocationInput?.filteredData || []);
        switch (type) {
            case "paginationModel":
                const previousFilterForLocation = locatFilters ? JSON.parse(locatFilters) : null;
                if (previousFilterForLocation?.paginationModel) {
                    return previousFilterForLocation.paginationModel;
                }
                return { page: 1, pageSize: 10 };
                break;
            case "filterInput":
                return inputFilter || "";
                break;
            case "activeProfile":
                const previousFilterForActiveProfile = locatFilters ? JSON.parse(locatFilters) : null;
                if (previousFilterForActiveProfile?.activeProfile) {
                    return previousFilterForActiveProfile.activeProfile;
                }
                break;
            case "others":
                return newFilters || [];
                break;
            default:
                break;
        }
    }

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const [anchorRight, setAnchorRight] = useState<null | HTMLElement>(null);
    const openRight = Boolean(anchorRight);

    const [inputValueFilter, setInputValueFilter] = useState<string>(getInitialLoadFilterFromState({ type: "filterInput" }));
    const [filteredData, setFilteredData] = useState<Filter[]>(getInitialLoadFilterFromState({ type: "others" }));
    const [paginationModel, setPaginationModel] = useState<GridPaginationModel>(getInitialLoadFilterFromState({ type: "paginationModel" }));

    const [filterTableModel, setFilterTableModel] = useState<GridFilterModel | undefined>()

    const [datesToAssigned, setDatesToAssigned] = useState({
        startDate: moment().subtract(1, 'month').startOf('day'),
        endDate: moment().endOf('day')
    })

    const [activeProfile, setactiveProfile] = useState<string>(getInitialLoadFilterFromState({ type: "activeProfile" }) || "");

    const [selectedRowId, setSelectedRowId] = useState<string | null>(null);

    const [userToAssignedActivities, setUserToAssignedActivities] = useState<any[]>([])

    const [showAssignActivityUnitary, setShowAssignActivityUnitary] = useState(false)

    const [selectedUserToAssignActivity, setSelectedUserToAssignActivity] = useState("")

    useEffect(() => {

        localStorage.setItem("locationListsFilters", JSON.stringify({
            paginationModel,
            filteredData,
            activeProfile: activeProfile !== "" ? activeProfile : undefined,
        }));

    }, [paginationModel, filteredData, activeProfile]);


    const [showFilters, setshowFilters] = useState(false)

    useEffect(() => {
        const CACHE_KEY = "listOfLocationWithDataCache";
        const CACHE_DURATION = 10 * 60 * 1000; // 10 minutes in milliseconds

        // Check cache before making API call
        const cachedData = localStorage.getItem(CACHE_KEY);
        let shouldFetch = true;

        console.log({ cachedData, shouldFetch });

        if (cachedData) {
            try {
                const parsedCache = JSON.parse(cachedData);
                const now = Date.now();
                const cacheAge = now - parsedCache.timestamp;

                // If cache is valid (less than 10 minutes old)
                if (cacheAge < CACHE_DURATION && parsedCache.data) {
                    // Load from cache directly into Redux
                    dispatch(gerenciaTecnicaSlice.actions.setLocationsWithData(parsedCache.data));
                    shouldFetch = false;
                }
            } catch (error) {
                console.log("Error parsing cache:", error);
                // If cache is corrupted, continue to fetch
            }
        }

        // Only fetch if cache is invalid or doesn't exist
        if (shouldFetch) {
            dispatch(getLocations());
        }

        const savedFilters = localStorage.getItem("locationListsFilters");
        const previousFilterForLocation = savedFilters ? JSON.parse(savedFilters) : null;

        if (previousFilterForLocation?.paginationModel) {
            setPaginationModel(previousFilterForLocation.paginationModel);
        }

        const tableFilterModel = previousFilterForLocation?.filteredData?.find((f: any) => f.name === 'tableModelFilter')?.value;

        if (tableFilterModel) {
            setFilterTableModel(tableFilterModel);
        } else {
            setFilterTableModel(undefined);
        }

        const parsedFilters = previousFilterForLocation?.filteredData;

        if (parsedFilters && parsedFilters.length > 0) {
            const { newFilters, inputFilter } = formatFilters(parsedFilters);
            setFilteredData(newFilters);
            setInputValueFilter(inputFilter);
        }

        setloadFilterFromState(false)

    }, []);


    useEffect(() => {
        let allLocations = listOfLocationWithData || [];

        const flags: any[] = []
        const warnings: any[] = []

        for (const location of allLocations) {
            if (!location?.locationTag || location?.locationTag?.length === 0) continue

            location?.locationTag?.forEach((tag: any) => {
                if (tag?.type === 'warning') {
                    if (!warnings.includes(tag?.name)) {
                        warnings.push(tag?.name);
                    }
                }
                if (tag?.type === 'flag') {
                    if (!flags.includes(tag?.name)) {
                        flags.push(tag?.name);
                    }
                }
            })

        }

        // Get unique activity values from allLocations
        const distinctActivities = Array.from(new Set(allLocations?.map((x) => x?.activity).filter(Boolean)));

        let originTypes = Array.from(new Set(allLocations?.map((x) => x?.type).filter(Boolean)));

        const asignedUser = Array.from(new Set(allLocations?.map((x) => x?.assignedAnalyzerUserName).filter(Boolean)));

        setfilters([
            ...defaultFilters,
            {
                name: 'Cuadrilla',
                field: 'type',
                type: 'Autocomplete',
                action: 'include',
                buttons: [],
                options: originTypes
            },
            {
                name: 'Actividades',
                field: 'activity',
                type: 'Autocomplete',
                action: 'include',
                buttons: [],
                options: distinctActivities
            },
            {
                name: 'Asignada a',
                field: 'assignedAnalyzerUserName',
                type: 'Autocomplete',
                action: 'include',
                buttons: [],
                options: asignedUser
            },
            {
                name: 'Etiquetas',
                field: 'locationTag',
                subField: 'name',
                type: 'Autocomplete',
                action: 'arrayInclude',
                buttons: [],
                options: flags
            },
            {
                name: 'Alertas',
                field: 'locationTag',
                subField: 'name',
                type: 'Autocomplete',
                action: 'arrayInclude',
                buttons: [],
                options: warnings
            }
        ])


        if (inputValueFilter !== "") {
            allLocations = allLocations.filter((x) => x.locationName.toLowerCase().includes(inputValueFilter.toLowerCase()));
        }

        for (const filter of filters) {
            const filterData = filteredData.find(f => f.name === filter.name);

            if (filterData) {
                if (filterData.action === 'greater') {
                    allLocations = allLocations.filter((x) => x[filter.field] > filterData.value);
                } else if (filterData.action === 'less') {
                    allLocations = allLocations.filter((x) => x[filter.field] < filterData.value);
                } else if (filterData.action === 'equal') {
                    allLocations = allLocations.filter((x) => x[filter.field] === filterData.value);
                    allLocations = allLocations.filter((x) => x[filter.field] === filterData.value);
                } else if (filterData.action === 'different') {
                    allLocations = allLocations.filter((x) => x[filter.field] !== filterData.value);
                } else if (filterData.action === 'arrayInclude') {
                    if (filter.subField && filterData.value.length > 0) {
                        allLocations = allLocations.filter((x) => {
                            const locationTags = x[filter.field]?.map((tag: any) => tag[filter.subField as keyof typeof tag]);
                            return locationTags?.some((tag: any) => filterData.value.includes(tag));
                        });
                    }
                } else if (filterData.action === 'include' && filterData.value.length > 0) {
                    allLocations = allLocations.filter((x) => filterData.value.includes(x[filter.field]));
                } else if (filterData.action === 'equalAfter') {
                    allLocations = allLocations.filter((x) => {
                        const locationDate = moment(x.executedDate).format('YYYY-MM-DD');
                        const filterDate = moment(filterData.value).format('YYYY-MM-DD');
                        return locationDate >= filterDate;
                    });
                } else if (filterData.action === 'equalBefore') {
                    allLocations = allLocations.filter((x) => {
                        const locationDate = moment(x.executedDate).format('YYYY-MM-DD');
                        const filterDate = moment(filterData.value).format('YYYY-MM-DD');
                        return locationDate <= filterDate;
                    });
                }
            }
        }
        setData(allLocations);

        const datatoAssigned = allLocations.filter((d) => d.lastActivityAnalized === false)

        setDataToAssigned(datatoAssigned);
    }, [listOfLocationWithData, inputValueFilter, filteredData]);

    const handleSelectChange = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setSelectedOption(event.target.value);
        setInputValueFilter("");
    };

    const handleFilterInput = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (loadFilterFromState) return;

        setInputValueFilter(event.target.value);
        const extraFilter = filteredData.filter(f => f.name !== 'filterInput');
        const newFilter: Filter = {
            name: 'filterInput',
            inputValueFilter: event.target.value,
            id: 0,
            action: "",
            value: undefined
        };
        setFilteredData([...extraFilter, newFilter]);
    };

    const handleSelectOptionFilter = (filter: Filter) => {
        const extraFilter = filteredData.filter(f => f.name !== filter.name);
        setFilteredData([...extraFilter, filter]);
        // dispatch(gerenciaTecnicaSlice.actions.setLocationListFilter(JSON.stringify([
        //     ...extraFilter,
        //     filter])));
    };

    const handleResetSearch = () => {
        setFilteredData([]);
        setInputValueFilter("");
        setData(listOfLocationWithData || []);
        localStorage.removeItem("locationListsFilters");
        setactiveProfile("");
    };


    const handleDownloadCSV = () => {
        try {

            const columnsToFile = [];

            if (data.length > 0) {

                const dataToExport: any[] = []

                data.forEach((row: any) => {
                    const newRow: any = {};
                    columns.forEach((col) => {
                        newRow[col?.headerName || col.field] = row[col.field] || "";
                    });

                    dataToExport.push(newRow);
                });

                const csv = convertArrayOfObjectsToCSV(dataToExport);
                const utf8Bom = "\uFEFF"; // UTF-8 BOM
                const csvWithBom = utf8Bom + csv;
                const blob = new Blob([csvWithBom], { type: "text/csv;charset=utf-8;" });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.setAttribute("hidden", "");
                a.setAttribute("href", url);
                const currentTime = new Date().toISOString().replace(/[:.]/g, "-");
                a.setAttribute("download", `list_locations_${currentTime}.csv`);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        } catch (error) {
            console.log({ error });
        }
    };

    const handleDownloadActivitiesAssignedToCurrentUser = () => {
        console.log("handleDownloadActivitiesAssignedToCurrentUser");
        const today = moment().endOf('day');
        const startDate = moment().subtract(1, 'month').startOf('month');

        downloadExcelFormatAnalyst(startDate.format('YYYY-MM-DD'), today.format('YYYY-MM-DD'), true);
        toast.info(
            "El archivo se está generando, por favor espere unos minutos para descargarlo.",
            {
                autoClose: 20000,
                icon: <>⏳</>
            }
        );

        setAnchorRight(null);
    }

    const handleOntableFilterChange = (model: any) => {
        if (loadFilterFromState) return;

        if (model.items.length === 0) {
            setFilterTableModel(undefined);
            setFilteredData((prev) => prev.filter(f => f.name !== 'tableModelFilter'));
            return;
        }

        const extraFilter = filteredData.filter(f => f.name !== 'tableModelFilter');
        const newFilter: Filter = {
            name: 'tableModelFilter',
            inputValueFilter: undefined,
            id: 0,
            action: "",
            value: model
        };
        setFilteredData([...extraFilter, newFilter]);
    }

    const handleShowAssignedModule = () => {
        const startDate = filteredData.find(f => f.name === 'Fecha Inicio')?.value;
        const endDate = filteredData.find(f => f.name === 'Fecha Fin')?.value || moment().endOf('day');

        const datatoAssigned = data.filter((d) => d.lastActivityAnalized === false)

        setDatesToAssigned({
            startDate: startDate,
            endDate: endDate
        })

        setDataToAssigned(datatoAssigned);
        setShowAssignedModule(true);
    }

    const handleSetProfileFilter = (profile: string, isAttachFilter = false, checked?: boolean) => {


        const isFromProfile = ["Sin Producción", "Sin Producción Sin Análisis", "Pendientes por Análisis", "Aportando Pendiente Por Análisis"]

        let preFilterData = !isAttachFilter
            ? filteredData.filter(f => !["Estado Operativo Inicio", "Estado Operativo Fin", "Pendiente de Analizar"].includes(f.name))
            : filteredData;

        let newFilterData: any[] = [];

        if (profile === "Sin Producción") {

            const profileStatus = [
                {
                    "id": 0,
                    "name": "Estado Operativo Inicio",
                    "value": [
                        "Sin Aporte",
                        "IT",
                        "Observación"
                    ],
                    "action": "include",
                    "field": "opeStatusInicio"
                },
                {
                    "id": 0,
                    "name": "Estado Operativo Fin",
                    "value": [
                        "Sin Aporte",
                        "IT",
                        "Sin Producción",
                        "Observación",
                        "Restaurado"
                    ],
                    "action": "include",
                    "field": "opeStatusFin"
                }
            ]

            newFilterData = [
                ...preFilterData,
                ...profileStatus
            ]
        }

        if (profile === "Sin Producción Sin Análisis") {
            const profileStatus = [
                {
                    "id": 0,
                    "name": "Estado Operativo Inicio",
                    "value": [
                        "Sin Aporte",
                        "IT",
                        "Observación"
                    ],
                    "action": "include",
                    "field": "opeStatusInicio"
                },
                {
                    "id": 0,
                    "name": "Estado Operativo Fin",
                    "value": [
                        "Sin Aporte",
                        "IT",
                        "Sin Producción",
                        "Observación",
                        "Restaurado"
                    ],
                    "action": "include",
                    "field": "opeStatusFin"
                },
                {
                    "id": 1,
                    "name": "Pendiente de Analizar",
                    "value": false,
                    "action": "equal",
                    "field": "lastActivityAnalized"
                }
            ]

            newFilterData = [
                ...preFilterData,
                ...profileStatus
            ]

        }

        if (profile === "Pendientes por Análisis") {
            const profileStatus = [
                {
                    "id": 1,
                    "name": "Pendiente de Analizar",
                    "value": false,
                    "action": "equal",
                    "field": "lastActivityAnalized"
                }
            ]

            newFilterData = [
                ...preFilterData,
                ...profileStatus
            ]
        }

        if (profile === "Aportando Pendiente Por Análisis") {
            const profileStatus = [
                {
                    "id": 0,
                    "name": "Estado Operativo Inicio",
                    "value": [
                        "Aportando",
                        "Operando",
                    ],
                    "action": "include",
                    "field": "opeStatusInicio"
                },
                {
                    "id": 0,
                    "name": "Estado Operativo Fin",
                    "value": [
                        "Aportando"
                    ],
                    "action": "include",
                    "field": "opeStatusFin"
                },
                {
                    "id": 1,
                    "name": "Pendiente de Analizar",
                    "value": false,
                    "action": "equal",
                    "field": "lastActivityAnalized"
                }
            ]

            newFilterData = [
                ...preFilterData,
                ...profileStatus
            ]

        }


        if (profile === "Solo pozos BM") {

            preFilterData = preFilterData.filter(f => f.name !== "Método");

            const newFilter = checked ? [{
                "id": 0,
                "name": "Método",
                "value": [
                    "BM"
                ],
                "action": "include",
                "field": "method"
            }] : []

            newFilterData = [
                ...preFilterData,
                ...newFilter
            ]
        }

        if (profile === "Solo pozos del día") {

            preFilterData = preFilterData.filter(f => !["Fecha Inicio", "Fecha Fin"].includes(f.name));

            const newFilter = checked ? [{
                "id": 0,
                "name": "Fecha Inicio",
                "field": "fromDate",
                "action": "equalAfter",
                "value": moment().subtract(1, 'day').startOf('day')
            },
            {
                "id": 0,
                "name": "Fecha Fin",
                "field": "toDate",
                "action": "equalBefore",
                "value": moment().endOf('day')
            }] : []

            newFilterData = [
                ...preFilterData,
                ...newFilter
            ]
        }

        if (profile === "Omitir revisiones y niveles") {

            preFilterData = preFilterData.filter(f => f.name !== "Actividades");

            const newFilter = checked ? [{
                "id": 0,
                "name": "Actividades",
                "value": [
                    "Carta Dinagrafica",
                    "Carta Leuter",
                    "Estudio Completo"
                ],
                "action": "include",
                "field": "activity"
            }] : []

            newFilterData = [
                ...preFilterData,
                ...newFilter
            ]
        }

        if (profile === "Limpiar Perfil") {
            newFilterData = preFilterData
        }

        if (profile === "Asignados a mí") {
            preFilterData = preFilterData.filter(f => f.name !== "Asignada a");

            const newFilter = checked ? [{
                "id": 0,
                "name": "Asignada a",
                "value": [activeUser?.name],
                "action": "include",
                "field": "assignedAnalyzerUserName"
            }] : []

            newFilterData = [
                ...preFilterData,
                ...newFilter
            ]
        }


        setFilteredData(newFilterData);
        // setAnchorEl(null)
        if (isFromProfile.includes(profile)) {
            setactiveProfile(profile);
        } else if (profile === "Limpiar Perfil") {
            setactiveProfile("");
        }
    }

    const isChecked = (profile: string) => {
        if (profile === "Solo pozos BM") {
            return filteredData.some(f => f.name === "Método" && f.value.includes("BM"));
        }

        if (profile === "Solo pozos del día") {
            const fromDateFilter = filteredData.find(f => f.name === "Fecha Inicio");
            const toDateFilter = filteredData.find(f => f.name === "Fecha Fin");
            return fromDateFilter?.value?.isSame(moment().subtract(1, 'day').startOf('day')) && toDateFilter?.value?.isSame(moment().endOf('day'), 'day');
        }

        if (profile === "Omitir revisiones y niveles") {
            return filteredData.some(f => f.name === "Actividades" && f.value.includes("Carta Dinagrafica") && f.value.includes("Carta Leuter") && f.value.includes("Estudio Completo"));
        }

        if (profile === "Asignados a mí") {
            return filteredData.some(f => f.name === "Asignada a" && f.value.includes(activeUser?.name));
        }

        return false;
    };

    const columns: GridColDef[] = [
        {
            field: "locationName",
            headerName: "Locación",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
        },
        {
            field: "method",
            headerName: "Método",
            headerAlign: "center",
            align: "center",
            flex: 0.5,
        },
        {
            field: "executedDate",
            headerName: "Fecha",
            align: "center",
            headerAlign: "center",
            flex: 0.6,
            renderCell: (params) => {
                // Format as YYYY-MM-DD
                return params.value
                    ? moment(params.value).format("DD-MM-YYYY")
                    : "";
            },
        },
        // { field: "zone", headerName: "Sector", flex: 0.5 },
        {
            field: "opeStatusInicio",
            headerName: "Estado Ini",
            align: "center",
            headerAlign: "center",
            flex: 0.6,
        },
        {
            field: "opeStatusFin",
            headerName: "Estado Fin",
            align: "center",
            headerAlign: "center",
            flex: 0.6,
        },
        // { field: "type", headerName: "Cuadrilla", flex: 1 },
        // { field: "pot", headerName: "Pot", flex: 0.4 },
        {
            field: "activity",
            headerName: "Actividad",
            align: "center",
            headerAlign: "center",
            flex: 0.5,
        },
        {
            field: "pumpCondition",
            headerName: "Condición de Fondo",
            align: "center",
            headerAlign: "center",
            flex: 0.6,
        },
        {
            field: "lastOptimizationActivity",
            headerName: "Última Recomendación",
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: "assignedAnalyzerUserName",
            headerName: "Asignada a",
            align: "center",
            headerAlign: "center",
            flex: 0.7,
        },
        {
            field: "lastActivityAnalized",
            headerName: "Por Análisis",
            type: "boolean",
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                return params.row.lastActivityAnalized ? "No" : "Si";
            },
            flex: 0.6,
        },
        {
            field: "action",
            headerName: "",
            sortable: false,
            filterable: false,
            flex: 0.3,
            align: "center",
            headerAlign: "center",
            renderHeader: () => (
                <IconButton onClick={() => console.log("Header action")}>
                    <MoreVertIcon />
                </IconButton>
            ),
            renderCell: (params) => {

                const rowId = params.row.locationId;

                return (
                    <>
                        <IconButton onClick={(event) => handleMenuDetailsClick(event, rowId)}>
                            <MoreVertIcon />
                        </IconButton>
                        <Menu
                            id="demo-positioned-menu"
                            aria-labelledby="demo-positioned-button"
                            anchorEl={menuDetails}
                            open={openMenuDetails}
                            onClose={handleMenuDetailsClose}
                        >
                            <Link
                                to={`/gto/dashboard/location/detail/${selectedRowId}`}
                                style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                }}
                            >
                                <MenuItem onClick={handleMenuDetailsClose}>
                                    Detalles
                                </MenuItem>
                            </Link>
                            {returnMenuItemsAssigneOrUnassigneActivities()}
                        </Menu >
                    </>
                );
            },
        },
    ];

    const returnMenuItemsAssigneOrUnassigneActivities = () => {

        const row = data.find(d => d.locationId === selectedRowId);

        if (!row) return;

        if (activeUser?.role.includes("gestion-tierra") && row.assignedAnalyzerUserId) {
            return (
                <MenuItem onClick={handleUnAssignActivity}>
                    Desasignar Actividad
                </MenuItem>
            );
        }

        if (activeUser?.role.includes("gestion-tierra") && !row.assignedAnalyzerUserId) {
            return (
                <MenuItem onClick={handleShowModalAssignActivity}>
                    Asignar Actividad
                </MenuItem>
            );
        }
    }

    //menu 
    const handleMenuDetailsClick = (event: React.MouseEvent<HTMLElement>, rowId: string) => {
        setMenuDetails(event.currentTarget);
        setSelectedRowId(rowId);
    };
    const handleMenuDetailsClose = () => {
        setMenuDetails(null);
    };

    const handleUnAssignActivity = () => {
        setMenuDetails(null);
        if (!selectedRowId) return;

        const row = data.find(d => d.locationId === selectedRowId);

        if (!row) return;

        console.log({ row });

        Swal.fire({
            title: `Desasignar Actividad`,
            text: `Estas seguro que desea desasignar la actividad del pozo ${row?.locationName}? asignada a ${row?.assignedAnalyzerUserName}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Continuar!",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(mainSlice.actions.updateState({ status: true }));
                assignedActivitiesToUser("", [], [row.activityId]).then((data) => {
                    Swal.fire({
                        title: "Guardado!",
                        icon: "success",
                    });
                    dispatch(getLocations(true));
                })
            }
        });

    }

    const handleShowModalAssignActivity = () => {
        setMenuDetails(null);
        if (!users || users.length === 0) return;

        const filteredUsers = users.filter(user => user?.role?.includes('Aplicaciones Tierra'));

        setUserToAssignedActivities(filteredUsers);

        setShowAssignActivityUnitary(true);
    }

    const handleCloseAssignActivityUnitary = () => {
        setShowAssignActivityUnitary(false);
        setSelectedUserToAssignActivity("");
    }

    const handleAssignActivityUnitary = () => {

        if (!selectedRowId) return;

        const row = data.find(d => d.locationId === selectedRowId);

        if (!row) return;

        if (selectedUserToAssignActivity === "") return toast.error("Debe seleccionar un usuario para asignar la actividad");

        dispatch(mainSlice.actions.updateState({ status: true }));

        const activityToAssign: ActivitiesByDatesToAssigned ={
            date: moment().format('YYYY-MM-DD'),
            assignedActivitiesIds: [row.activityId]
        }

        assignedActivitiesToUser(selectedUserToAssignActivity, [activityToAssign], []).then((data) => {
            Swal.fire({
                title: "Guardado!",
                icon: "success",
            });
            dispatch(getLocations(true));
            handleCloseAssignActivityUnitary();
        })
    }

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid size={12} sx={{ mt: 2 }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            alignContent: "center",
                        }}
                    >
                        <Grid
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: 2,
                            }}
                        >
                            <IconButton
                                size="medium"
                                color="primary"
                                sx={{
                                    border: "1px solid #468decff",
                                    borderRadius: 2,
                                }}
                                onClick={(event) => {
                                    setAnchorEl(event.currentTarget);
                                }}
                            >
                                <FilterAltIcon fontSize="small" />
                            </IconButton>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={() => setAnchorEl(null)}
                                MenuListProps={{
                                    "aria-labelledby": "basic-button",
                                }}
                            >
                                {[
                                    "Sin Producción",
                                    "Sin Producción Sin Análisis",
                                    "Pendientes por Análisis",
                                    "Aportando Pendiente Por Análisis",
                                ].map((profile) => (
                                    <MenuItem key={profile}>
                                        <Grid
                                            className={`sub_menu_profile_menu ${activeProfile === profile
                                                ? "active_menu"
                                                : ""
                                                }`}
                                        >
                                            <Grid
                                                onClick={() =>
                                                    handleSetProfileFilter(
                                                        profile
                                                    )
                                                }
                                            >
                                                {profile}
                                            </Grid>
                                            {profile === activeProfile && (
                                                <IconButton
                                                    size="medium"
                                                    color="warning"
                                                    onClick={() =>
                                                        handleSetProfileFilter(
                                                            "Limpiar Perfil"
                                                        )
                                                    }
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                            )}
                                        </Grid>
                                    </MenuItem>
                                ))}
                                <MenuItem disabled>
                                    ________________________________________
                                </MenuItem>
                                <FormGroup className="sub_menu_profile_menu_switch_secction">
                                    {[
                                        "Solo pozos del día",
                                        "Solo pozos BM",
                                        "Omitir revisiones y niveles",
                                        "Asignados a mí",
                                    ].map((profile) => (
                                        <FormControlLabel
                                            key={profile}
                                            control={
                                                <Switch
                                                    checked={isChecked(profile)}
                                                    onChange={(event) =>
                                                        handleSetProfileFilter(
                                                            profile,
                                                            true,
                                                            event.target.checked
                                                        )
                                                    }
                                                />
                                            }
                                            label={profile}
                                        />
                                    ))}
                                </FormGroup>
                                <MenuItem disabled>
                                    ________________________________________
                                </MenuItem>
                                <MenuItem onClick={() => handleResetSearch()}>
                                    <IconButton size="small" color="primary">
                                        <RestartAltOutlinedIcon fontSize="small" />
                                    </IconButton>
                                    Resetear Filtros
                                </MenuItem>

                                {/* TO DO ADD */}
                            </Menu>
                            <SelectBoxSearch
                                options={options}
                                selectedOption={selectedOption}
                                onOptionChangeSelectBox={handleSelectChange}
                                onValueChangeInput={handleFilterInput}
                                inputValue={inputValueFilter}
                            />
                        </Grid>

                        <Grid>
                            {activeUser?.role.includes("gestion-tierra") && (
                                <Button
                                    variant="outlined"
                                    sx={{ mr: 5 }}
                                    onClick={() => handleShowAssignedModule()}
                                >
                                    <Typography sx={{ fontSize: "14px" }}>
                                        Gestión de Asignaciones
                                    </Typography>
                                </Button>
                            )}
                            <IconButton
                                size="small"
                                color="primary"
                                sx={{ mr: 2 }}
                                onClick={() => setshowFilters(!showFilters)}
                            >
                                <TuneIcon />
                            </IconButton>
                            <IconButton
                                size="small"
                                color="primary"
                                sx={{ mr: 2 }}
                                onClick={(event) =>
                                    setAnchorRight(event.currentTarget)
                                }
                            >
                                <DownloadIcon />
                            </IconButton>
                            <IconButton
                                size="small"
                                color="primary"
                                sx={{ mr: 2 }}
                                onClick={() => dispatch(getLocations(true))}
                                title="Recargar datos"
                            >
                                <RestartAltOutlinedIcon />
                            </IconButton>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorRight}
                                open={openRight}
                                onClose={() => setAnchorRight(null)}
                                MenuListProps={{
                                    "aria-labelledby": "basic-button",
                                }}
                                sx={{
                                    marginTop: "5px",
                                    border: "1px solid #e0e0e0",
                                    boxShadow: "0px 4px 16px rgba(0,0,0,0.08)",
                                }}
                            >
                                <MenuItem>
                                    <Grid className={`sub_menu_profile_right`}>
                                        <Grid
                                            onClick={() => handleDownloadCSV()}
                                        >
                                            Descargar Lista de Locaciones
                                        </Grid>
                                    </Grid>
                                </MenuItem>
                                <MenuItem>
                                    <Grid className={`sub_menu_profile_right`}>
                                        <Grid
                                            onClick={() =>
                                                handleDownloadActivitiesAssignedToCurrentUser()
                                            }
                                        >
                                            Descargar Lista de Actividades
                                            Asignadas a mi
                                        </Grid>
                                    </Grid>
                                </MenuItem>
                            </Menu>
                        </Grid>
                    </Box>
                </Grid>

                {showAssignedModule && (
                    <ActivitiesManagerModule
                        datesToAssigned={datesToAssigned}
                        data={datatoAssigned}
                        open={showAssignedModule}
                        onClose={() => setShowAssignedModule(false)}
                    />
                )}

                <FilterDrawer
                    showFilters={showFilters}
                    filters={filters}
                    filteredData={filteredData}
                    setshowFilters={setshowFilters}
                    handleSelectOptionFilter={handleSelectOptionFilter}
                    resetFilters={handleResetSearch}
                />

                <Grid size={12}>
                    <DataGrid
                        rows={data}
                        columns={columns.map((col) => ({
                            ...col,
                            // disableColumnMenu: true, // Elimina el ícono de menú contextual
                        }))}
                        initialState={{ pagination: { paginationModel } }}
                        onPaginationModelChange={setPaginationModel}
                        paginationModel={paginationModel}
                        pageSizeOptions={[10, 20, 50, 100]}
                        checkboxSelection={false}
                        filterModel={filterTableModel}
                        onFilterModelChange={handleOntableFilterChange}
                        sx={{
                            height: {
                                md: `calc(100vh - 305px)`,
                                lg: `calc(100vh - 305px)`,
                                xl: `calc(100vh - 310px)`,
                            },
                            ...tableStyles,
                        }}
                        getRowId={(row) => row.locationId}
                    />
                </Grid>
            </Grid>
            {showAssignActivityUnitary && (
                <>
                    <Grid
                        className="modal_assign_activity_external"
                        onClick={() => handleCloseAssignActivityUnitary()}
                    />
                    <Grid className="modal_assign_activity_body">
                        <Box className="header_modal_activity">
                            <Typography className="">Asignar Actividad</Typography>
                            <IconButton className="close-btn" onClick={() => handleCloseAssignActivityUnitary()}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <Box className="body_modal_activity">
                            <FormControl className="select_list" fullWidth>
                                <InputLabel>Selecciona el usuario a asignar</InputLabel>
                                <Select
                                    value={selectedUserToAssignActivity}
                                    onChange={e => setSelectedUserToAssignActivity(e.target.value)}
                                    displayEmpty
                                    label="Selecciona el usuario a asignar"
                                    size="small"
                                    className="select_filter"
                                >
                                    {userToAssignedActivities?.map((user, index) => <MenuItem key={index} value={user.id}>{user.name}</MenuItem>)}
                                </Select>
                            </FormControl>
                            <Button
                                className="button_assign_activity"
                                variant="contained"
                                onClick={() => handleAssignActivityUnitary()}
                            >
                                Asignar
                            </Button>
                        </Box>
                    </Grid>
                </>
            )}
        </Box>
    );
};

export default ListLocation;
